import { render } from "./EMailEditor.vue?vue&type=template&id=1d368b80"
import script from "./EMailEditor.vue?vue&type=script&lang=js"
export * from "./EMailEditor.vue?vue&type=script&lang=js"

import "./EMailEditor.vue?vue&type=style&index=0&id=1d368b80&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__